import React from 'react';

const Section = ({ id, children, className = "" }) => {
    return (
        <section id={id} className={`py-20 px-6 md:px-12 ${className}`}>
            <div className="max-w-5xl mx-auto">
                {children}
            </div>
        </section>
    );
};

export default Section;
